import React from "react";
import ServiceDetail from "@/pages/services/ServiceDetail";

const Refrigerator = () => <ServiceDetail slug="refrigerator" />;
export default Refrigerator;
